import { IBaseMigrationItemCode } from '../../../interfaces';
import { ItemCodesMappingHandler } from '../../../mappings/item-codes';
import {
  CorePracticeItemCode,
  ICorePracticeItemCode,
  ItemCodeSourceEntity,
} from '../../source/entities/item-codes';

export class CorePracticeItemCodeMappingHandler extends ItemCodesMappingHandler<
  CorePracticeItemCode,
  ItemCodeSourceEntity
> {
  override sourceEntity = new ItemCodeSourceEntity();
  override translateFn = (
    record: ICorePracticeItemCode
  ): IBaseMigrationItemCode => ({
    ...record,
    description: record.name,
  });
}
